<template>
    <el-dialog
    class="logical-warehouse-dialog"
    title="修改逻辑仓"
    v-dialogDrag
    width="600px"
    top="8vh"
    :visible.sync="visible"
    :before-close="onClose"
>
        <div class="logical-warehouse-container">
            <vxe-table border :data="tableData" align="center" max-height="395px" size="mini">
                <vxe-column field="legalContractCode" title="法务合同号" show-overflow-tooltip></vxe-column>
                <vxe-column field="workerName" title="名称" show-overflow-tooltip></vxe-column>
                <vxe-column field="mainLogicalWarehouseName" title="主工作逻辑仓" show-overflow-tooltip></vxe-column>
            </vxe-table>
            <div class="logical-warehouse-row">
                <div class="edit-label">修改为：</div>
                <el-form
                    class="operate-delegate-form"
                    ref="form"
                    :model="form"
                    :rules="rules"
                    size="mini"
                    label-position="left">
                    <el-form-item label="主工作逻辑仓" prop="mainLogicalWarehouseName">
                        <SrmAdvance
                            :params="logicalWarehouseParams"
                            :mValue="form.mainLogicalWarehouseName"
                            :icon123="'el-icon-s-custom'"
                            @getAdvanceValue="getAdvanceValue($event, 'mainLogicalWarehouseName')" />
                    </el-form-item>
                </el-form>
                <!-- <div class="logical-warehouse-item"></div> -->
            </div>
        </div>

        <span slot="footer">
            <el-button @click="onClose">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="onEdit">确定修改</el-button>
        </span>
    </el-dialog>
</template>
<script>
import SrmAdvance from '../../../components/srmAdvance/index.vue'
import {
    changeMainLogicalWarehouse,
    // getDelegateDetail,
} from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js'

// 操作表单校验规则
export const RULES = {
    mainLogicalWarehouseName: [{ required: true, message: '请选择主工作逻辑仓', trigger: ['change'] }],
}
export default {
    components: { SrmAdvance },
    props: {},
    data() {
        return {
            form: {
                warehouseDelegateNoList: [],
                mainLogicalWarehouseName: '',
                mainLogicalWarehouseCode: '',
            },
            logicalWarehouseParams: {
                name: '主工作逻辑仓',
                value: 'cdwhName',
                type: 'advance',
                advanceLabel: '逻辑仓弹出框',
                advanceConfig: [
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                    { prop: 'whCode', value: '逻辑仓编码' }
                ],
                tableConfig: [
                    { prop: 'whCode', value: '逻辑仓编码' },
                    { prop: 'cdwhName', value: '名称' },
                ],
                advanceUrl: '/public/api/searchCdWarehouse',
                prefix: '/api-srm',
                method: 'get',
                cbParams: ['cdwhName#mainLogicalWarehouseName', 'whCode#mainLogicalWarehouseCode'],
                // advanceCascade: 'companyCode#cdRunSiteCodes',
                // multiple: true,
                // multipleTableColumn: { prop: 'cdwhName', value: '名称' },
                // // multipleDelConfirm: true,
                // max: 10,
            },
            rules: { ...RULES },
            tableData: [],
            loading: false,
            visible: false,
        }
    },
    methods: {
        show(rows) {
            this.visible = true
            this.tableData = rows
            this.form.warehouseDelegateNoList = rows.map(item => item.warehouseDelegateNo)
        },
        onClose() {
            this.tableData = []
            this.form.warehouseDelegateNoList = []
            this.form.mainLogicalWarehouseCode = ''
            this.form.mainLogicalWarehouseName = ''
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.visible = false
            })
        },
        getParams() {
            return { ...this.form }
        },
        onEdit() {
            this.loading = true
            this.$refs['form']
                .validate()
                .then(() => {
                    changeMainLogicalWarehouse(this.getParams())
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('保存成功!')
                                this.onClose()
                                this.$emit('refresh')
                            }
                        })
                        .finally(() => {
                            this.loading = false
                        })
                })
                .catch(() => {
                    this.loading = false
                })
        },
        getAdvanceValue(val, prop) {
            if (prop === 'mainLogicalWarehouseName') {
                this.form.mainLogicalWarehouseName = val.mainLogicalWarehouseName
                this.form.mainLogicalWarehouseCode = val.mainLogicalWarehouseCode
            }
        },
    },
}
</script>
<style scoped lang="less">
.logical-warehouse-dialog {
    .logical-warehouse-row {
        width: 400px;
        display: flex;
        // justify-content: space-between;
        // padding: 0 10px;
        margin-top: 10px;

        .edit-label {
            padding-top: 5px;
            padding-right: 15px;
            font-weight: bold;
        }
    }
    /deep/ .el-form-item__label {
        display: none;
    }
}
</style>
